import {
    THEME,
    THEME_SET_SUCCESS,
    THEME_SET_TRIGGER
} from "../actionType";


import WHITELABELING from "../../Components/Themes";
import { THEME_CALL, THEME_CALL_CONTRAST, THEME_CALL_FONTSIZE } from "../../Components/Themes/Theme";
import { getTenantName } from "../../Utils";

const INITIAL_STATE = {
    initalThemeValues: { ...WHITELABELING },
    values: { ...WHITELABELING }
};

const theme = (state = INITIAL_STATE, action) => {
    
    switch (action.type) {
        case THEME:
            return {
                ...state,
            };

        case THEME_SET_TRIGGER:
            return action.payload;
        case THEME_SET_SUCCESS:
            try {
                
                const res = {
                    appIdToTenantMap: action.payload.appIdToTenantMap,
                    tenants: []
                };

                if (action.payload.tenants) {

                    action.payload.tenants.forEach(e => {
                        const tenants = res.tenants;
                        res.tenants = { ...tenants, ...e };
                    })

                    action.payload.appIdToTenantMap['localhost'] = "elevatefi";
                    const tenantName = getTenantName(action.payload.appIdToTenantMap); //"DemoBank";//getTenantName();
                    
                    let resEntity = res.tenants[tenantName];
                    resEntity.baseDomain = resEntity.baseUrl;
                    resEntity.baseUrl = `https://${resEntity.baseUrl}`;
                    resEntity.gray5 = `#D3D7D7`;
                    resEntity.shortName = resEntity.shortName.replace(/\s/g, '');
                    resEntity.tenantFullName = tenantName;
                    //resEntity.navLocation = "Page-Left";

                    document.querySelectorAll(`body`).forEach(e => e.setAttribute("id", "tenant-" + tenantName.toLowerCase()));
                    document.title = resEntity.shortName;

                    let initalThemeValues = JSON.parse(JSON.stringify(resEntity));
                    
                    resEntity = THEME_CALL_CONTRAST(resEntity);

                    const isWhitelabel = resEntity?.showHeader === false;
                    sessionStorage.setItem("isWhitelabel", String(isWhitelabel));

                    THEME_CALL_FONTSIZE();
                    THEME_CALL(resEntity);

                    const finalState = {
                        initalThemeValues: { ...state.initalThemeValues, ...initalThemeValues },
                        values: { ...state.values, ...resEntity }
                    }
                    return finalState;
                } else {
                    return state;
                }
            } catch (err) {
                // Error handling for theme
            }
            return state;
        default:
            return state;
    }
};
export default theme;